import { IntlFormatters } from 'react-intl';

import {
  DEFAULT_PAYMENT_COUNTRY,
  DEFAULT_PAYMENT_CURRENCY
} from './default-codes/default-payment-codes';

export enum ISOs {
  USA = 'USA',
  CAN = 'CAN',
  GBR = 'GBR',
  US = 'USA',
  CA = 'CAN',
  GB = 'GBR'
}

export enum RegionToISOs {
  US = ISOs.USA,
  CA = ISOs.CAN,
  GB = ISOs.GBR
}

export enum ISOsToRegions {
  USA = 'US',
  CAN = 'CA',
  GBR = 'GB'
}

export enum PaymentISOs {
  US = 'US',
  CA = 'CA',
  GB = 'GB'
}

export enum Currencies {
  USD = 'USD',
  CAD = 'CAD',
  GBP = 'GBP'
}

export {
  DEFAULT_PAYMENT_COUNTRY,
  DEFAULT_PAYMENT_CURRENCY
} from './default-codes/default-payment-codes';

export const getCountryAndCurrencyCodes = (
  billingCountry: ISOs
): { countryCode: PaymentISOs; currencyCode: Currencies } => {
  const defaultCodes = {
    countryCode: DEFAULT_PAYMENT_COUNTRY,
    currencyCode: DEFAULT_PAYMENT_CURRENCY
  };
  return (
    {
      [ISOs.USA]: { countryCode: PaymentISOs.US, currencyCode: Currencies.USD },
      [ISOs.CAN]: { countryCode: PaymentISOs.CA, currencyCode: Currencies.CAD },
      [ISOs.GBR]: { countryCode: PaymentISOs.GB, currencyCode: Currencies.GBP }
    }[billingCountry] || defaultCodes
  );
};

/**
 * These are ISO Country Codes. This array will likely be expanded in the future.
 */
export const getCountryOptions = (
  formatMessage: IntlFormatters['formatMessage']
): { value: ISOs | string; label: string }[] => [
  { value: ISOs.USA, label: formatMessage({ id: 'unitedStates' }) },
  { value: ISOs.CAN, label: formatMessage({ id: 'canada' }) }
];

export const postalCodeStringLocaleKey = {
  [ISOs.USA]: 'zipCode',
  [ISOs.CAN]: 'postalCode',
  [ISOs.GBR]: 'postalCode'
};

export const postalCodeInputProperties = {
  [ISOs.USA]: { maxLength: '5', pattern: '[0-9]*' },
  [ISOs.CAN]: { maxLength: '6' },
  [ISOs.GBR]: { maxLength: '10' }
};

export const regionStringLocaleKey = {
  [ISOs.USA]: 'state',
  [ISOs.CAN]: 'province',
  [ISOs.GBR]: 'province'
};

export const regionInputProperties = {
  [ISOs.USA]: { maxLength: '2' },
  [ISOs.CAN]: { maxLength: '2' },
  [ISOs.GBR]: { maxLength: '2' }
};
